import { gql } from '@apollo/client';

export const mutation = gql`
  mutation AddTagToPipeline($pipelineId: uuid!, $label: String!, $type: tag_types_enum!) {
    insert_pipeline_tags_one(
      object: {
        pipelineId: $pipelineId
        tag: {
          data: { label: $label, type: $type }
          on_conflict: { constraint: tags_org_id_type_label_key, update_columns: [label] }
        }
      }
    ) {
      id
      pipelineId
      tagId
    }
  }
`;

export function buildVariables({ pipelineId, label, type }) {
  return { pipelineId, label, type };
}
